import { atom } from "jotai";

export const isEditDescriptionModalOpenAtom = atom(false);

isEditDescriptionModalOpenAtom.debugLabel = "isEditDescriptionModalOpenAtom";
